<template>
  <v-app :class="{inHomeInitial}">
    <v-toolbar app fixed
      temporary class="elevation-0 toolbar" dark
      :height="height"
      :color="inHomeInitial ? '#131d1f':''">
      <router-link class="router-link"
        v-if="!inHomeInitial && currentRoute !== 'Home' && $routerHistory.hasPrevious()"
        :to="{ path: $routerHistory.previous().path }">
        <v-btn icon>
          <v-icon>arrow_back_ios</v-icon>
        </v-btn>
      </router-link>

      <v-btn style="z-index:99999; position:relative;"
        v-if="!inHomeInitial && currentRoute !== 'Home' && !$routerHistory.hasPrevious()"
        @click="goBack" icon>
        <v-icon>arrow_back_ios</v-icon>
      </v-btn>

<!--       <v-btn icon :to="'/search'" class="hidden-sm-and-up" style="z-index:99999;" v-if="!inHomeInitial">
        <v-icon>search</v-icon>
      </v-btn> -->

      <v-toolbar-title class="headline text-uppercase" :class="{inHomeInitial}">
        <img class="logo_terror"  @click="goHome" :src="logo"/>
      </v-toolbar-title>
      <v-spacer></v-spacer>


<!--       <v-btn outline id="mylist" class="mylist"
        style="border:0;"
        text :to="{name: 'MyList'}"
        v-if="!inHomeInitial && $store.getters.isAuthenticated"> -->
<!--         <v-list-tile class="milist" :to="{name: 'MyList'}"
        v-if="!inHomeInitial && $store.getters.isAuthenticated">
          <v-list-tile-title>Mi lista</v-list-tile-title>
        </v-list-tile> -->
      <!-- </v-btn> -->

<!--       <v-btn icon :to="'/search'" class="hidden-xs-only" v-if="!inHomeInitial">
        <v-icon>search</v-icon>
      </v-btn> -->
      <v-toolbar-items>
<!--         <v-menu bottom left offset-y v-if="false">
          <v-btn slot="activator" flat>
            {{ currentLang }}
            <v-icon>language</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile v-for="(l, i) in lang" :key="i" @click="selectLanguage(l)">
              <v-list-tile-title>{{ l.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu> -->

        <v-flex class="land-wrapper" v-if="inHomeInitial">
          <!-- <v-layout> -->
            <v-btn class="land-icons" color="primary" to="/signin">{{$t('navMenu.signIn')}}</v-btn>
            <v-btn class="land-icons" color="primary" to="/signup">{{$t('navMenu.signup')}}</v-btn>
          <!-- </v-layout> -->
        </v-flex>

        <v-menu bottom left offset-y>
          <v-btn icon slot="activator" class="menu-icon" flat>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list class="menuflex" style="display: flex; flex-direction: column">
            <v-list-tile v-for="(item, i) in menuItems"
              :key="i"
              :to="item.path"
              v-if="show(item)"
              :class="item.class">
              <v-list-tile-action>
                <v-icon> {{ item.icon }} </v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ item.displayName }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :href="terms" target="_blank">
              <v-list-tile-action>
                <v-icon>library_books</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{$t('navMenu.terms')}}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :href="privacy" target="_blank">
              <v-list-tile-action>
                <v-icon>school</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{$t('navMenu.privacy')}}</v-list-tile-title>
            </v-list-tile>

<!--             <v-list-tile href="https://microcanales-cne-df069.appspot.com.storage.googleapis.com/cookie.html" target="_blank">
              <v-list-tile-action>
                <v-icon>group_work</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{$t('navMenu.cookies')}}</v-list-tile-title>
            </v-list-tile> -->

            <v-list-tile :href="about" target="_blank">
              <v-list-tile-action>
                <v-icon>help</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{$t('navMenu.about')}}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :href="facebook" target="_blank">
              <v-list-tile-action>
                <v-icon color="secondary">$vuetify.icons.facebook</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Facebook</v-list-tile-title>
            </v-list-tile>

<!--             <v-list-tile href="https://twitter.com/microcanales/" target="_blank">
              <v-list-tile-action>
                <v-icon color="secondary">$vuetify.icons.twitter</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Twitter</v-list-tile-title>
            </v-list-tile> -->

            <v-list-tile :href="instagram" target="_blank">
              <v-list-tile-action>
                <v-icon color="secondary">$vuetify.icons.instagram</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Instagram</v-list-tile-title>
            </v-list-tile>

          </v-list>
          <div>
            <div class="appMarkets">
              <v-flex xs12>
                <a :href="iosUrl">
                  <img :src="iosImage"/>
                </a>
              </v-flex>
              <v-flex xs12>
                <a :href="androidUrl">
                  <img :src="androidImage"/>
                </a>
              </v-flex>
              <!-- <v-flex xs12>
                <a href="#">
                  <img src="/samsung_smart_tv.jpg" style="object-fit: contain;height: 78%;"/>
                </a>
              </v-flex> -->
            </div>
            <v-layout row class="menuFooter">
              <p>AMC Mikro © 2021 - AMC</p>
            </v-layout>
          </div>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-alert v-if="info"
      class="info-alert"
      dismissible
      v-model="$store.state.infoEnable"
      :value="info"
      :type="infoType"
      transition="scale-transition"
    >
      {{ info }}
    </v-alert>

    <v-content>
      <transition name="slide-left" mode="out-in">
        <keep-alive>
          <router-view id="scrolling-techniques"></router-view>
        </keep-alive>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import logo from '@/assets/logo-mikro.png'
import facebook from '@/assets/facebook.svg'
import instagram from '@/assets/instagram.svg'
import appstore from '@/assets/appstore.svg'
import googleplay from '@/assets/googleplay.svg'
import { storage, brightcove } from '@/config'

const configLogo = {
  'microcanales-cne-df069': '/logo-mikro.png',
  'amc-mikro-cz': '/logo-mikro.png'
}
const fid = storage._delegate._bucket.bucket.split('.')[0]
const siteId = fid === 'microcanales-cne-df069' ? 'hun' : 'cz'

export default {
  name: 'App',
  data () {
    return {
      active: true,
      drawer: false,
      scrolled: false,
      lastScrollPosition: 0,
      lang: [
        { title: 'ES' },
        { title: 'EN' }
      ],
      logo: configLogo[fid],
      iosUrl: brightcove[siteId].iosUrl,
      iosImage: brightcove[siteId].iosImage,
      androidUrl: brightcove[siteId].androidUrl,
      androidImage: brightcove[siteId].androidImage,
      facebook: brightcove[siteId].facebook,
      instagram: brightcove[siteId].instagram,
      terms: brightcove[siteId].terms,
      privacy: brightcove[siteId].privacy,
      about: brightcove[siteId].about
    }
  },
  created () {
    this.$store.dispatch('initialize')
  },
  computed: {
    ...mapGetters(['admin', 'videoBack', 'info', 'infoType']),
    height() {
      return this.inHomeInitial ? '64px' : '64px'
    },
    inHomeInitial() {
      return this.$route.path === '' || this.$route.path === '/'
    },
    currentLang () {
      return this.$i18n.locale.toUpperCase()
    },
    currentRoute () {
      return this.$route.name
    },
    menuItems () {
      const from = this.$route.path.length > 2 ? `?from=${this.$route.path}` : ''
      return [
        // { displayName: this.$t('mylist'), icon: 'view_list', path: '/mylist', requireAuth: true },
        // { displayName: this.$t('¿Qué es Microcanales?'), icon: 'mail', path: '/ayuda', class: 'order1' },
        { displayName: this.$t('navMenu.profile'), icon: 'person', path: '/profile', requireAuth: true },
        // { displayName: this.$t('navMenu.terms'), icon: 'library_books', path: '/terminos-y-condiciones' },
        { displayName: this.$t('navMenu.registro'), icon: 'person_add', path: `/signup${from}`, notAuthenticated: true, class: 'order0', notInHomeInitial: true },
        { displayName: this.$t('navMenu.signIn'), icon: 'person_add', path: `/signin${from}`, notAuthenticated: true, class: 'order0', notInHomeInitial: true },
        { displayName: this.$t('navMenu.signOut'), icon: 'reply', path: '/signout', requireAuth: true, class: 'order0' }
      ]
    }
  },
  methods: {
    goHome () {
      this.$router.push('/')
    },
    goBack () {
      history.back()
    },
    show (item) {
      if (item.notInHomeInitial && this.inHomeInitial) {
        return false
      } else if (item.notAuthenticated) {
        return !this.$store.getters.isAuthenticated
      } else if (item.requireAdmin) {
        return this.admin
      } else if (item.requireAuth) {
        return this.$store.getters.isAuthenticated
      }
      return true
    },
    selectLanguage (lang) {
      this.$i18n.locale = lang.title.toLowerCase()
      localStorage.setItem('currentLanguage', this.$i18n.locale)
    },
    onScroll() {
      const currentScrollPosition = document.documentElement.scrollTop
      const minHeight = window.innerWidth < 400 ? 30 : 60
      this.scrolled = currentScrollPosition > minHeight

      // if (currentScrollPosition < 0) {
      //   return
      // }
      // // Stop executing this function if the difference between
      // // current scroll position and last scroll position is less than some offset
      // if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
      //   return
      // }
      // this.scrolled = currentScrollPosition < this.lastScrollPosition
      // this.lastScrollPosition = currentScrollPosition
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>


<style>
.bvue-ui-modal.bvue-ui-full {
  pointer-events: none !important;
}
.bvue-ui-modal-content {
  pointer-events: all !important;
}
  .inHomeInitial .v-content__wrap {
    overflow-x: hidden !important;
  }
  .inHomeInitial nav {
    /*filter: invert(1) !important;*/
    box-shadow: none !important;
  }
  .toolbar {
    /*background: black;*/
/*    height: 154px !important;
    margin-top: -87px !important;
    background: black !important;*/
  }
  .headline.inHomeInitial {  
    width: 300px !important;
    text-align: left !important;
    top: 10px;
    width: 140px !important;
  }
  .headline.inHomeInitial .logo_terror {
    /*transition: height .5;*/
    /*height: 60px !important;*/
  }
  .inHomeInitial .land-wrapper {
    /*filter: invert(1);*/
    height: 36px;
    zoom: .9;
  }
  .inHomeInitial .land-icons {
    margin: 18px 5px !important;
  }
  .scrolled.inHomeInitial {
    top: 10px !important;
  }
  .scrolled.inHomeInitial .logo_terror {
    /*height: 40px !important;*/
  }
  .flex.sm3.custom {
    padding-right: 10px;
  }
  .appMarkets {
    text-align: center;
  }

  .milist {
    filter: grayscale(1);
    text-transform: uppercase;
    zoom: .8;
  }
  .milist .v-list__tile--active {
    background-color: lightgray !important;
  }
  @media (max-width: 320px) {
    .milist {
      margin: -25px !important;
      zoom: .65;
    }
  }
  @media (max-width: 600px) {
    .milist {
      padding: 0 !important;
      margin: -18px !important;
    }
    .headline.inHomeInitial {
      width: 102px !important;
      top: 10px;
    }

    .headline.inHomeInitial .logo_terror {
      height: 30px !important;
    }
    .inHomeInitial .land-wrapper {
      height: 36px;
      zoom: none !important;
      transform: scale(.8);
      transform-origin: right;
      margin-right: -16px;
    }
    .inHomeInitial .land-icons {
      margin: 18px 5px !important;
    }
    .inHomeInitial .menu-icon {
      transform: scale(.8);
      transform-origin: right;
      margin-right: -10px;
    }
  }
  @media (min-width: 600px) {

    .flex.sm3.custom {
      flex-basis: 33%;
      /*flex-grow: 0;*/
      max-width: 33%;
    }
  }
  .v-content__wrap:before {
    content: ' ';
    /*background: url(/mancha_negra_1.png);*/
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    width: 100%;
    height: 100%;
    top: -19vw;
    transition: background 2s;
    pointer-events: none;
  }
  .application--wrap {
    overflow: hidden;
  }
  .logo_terror {
    background-size: unset !important;
    padding-top: 5px;
    padding-left: 8px;
    height: 40px;
    cursor: pointer;
  }
  .v-toolbar {
    box-shadow: 0 0 1pt #333 !important;
  }
  .headline {
    font-family: -apple-system, system-ui, system-ui, 'Segoe UI', Montserrat, 'Helvetica Neue', sans-serif !important;
    user-select: none;
    width: calc(100% - 32px);
    /*position: absolute;*/
    margin-left: 0 !important;
    font-size: 30px !important;
    font-weight: bolder;
    text-align: center;
    position: absolute;
  }
  .planet {
    padding: 0;
    padding-top: 10px;
    margin: 0;
    display: inline-block;
    line-height: 1em;
    font-weight: bolder;
    vertical-align: top;
  }
  .horror {
    padding: 0;
    margin: 0;
    display: inline-block;
    line-height: .5em;
    font-weight: bolder;
    vertical-align: top;
  }
  .router-link, .router-link-active {
    position: relative;
    left: 0;
    color: white;
    z-index: 1;
    text-decoration: none;
  }
  .router-link .v-icon {
    margin-left: 8px !important;
  }

  /* transition */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translateY(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translateY(-2em);
}

/* Reorder item in menu */
.order0 {
  order: -1;
}
.order1 {
  order: 2;
}

  .info-alert {
    position: absolute;
    top: 100px;
    z-index: 9999;
    width: calc(100% - 64px);
    left: 32px;
  }


.appMarkets, .menuFooter {
  background-color: #fff;
  padding: 5px 15px; 
}
.appMarkets img{ 
  width: 140px;
  max-width: 100%;
}
.appMarkets img:first-child{ 
  margin-right: 10px;
}

.menuFooter p {
  width: 100%;
  text-align: center;
}


</style>
